import React from "react";
import ContractTAGServiceContainer from "components/containers/ContractTAGServiceContainer/ContractTAGServiceContainer";


function ContractTAGServiceRoute(){
  return(
    <ContractTAGServiceContainer/>
  )
}

export default ContractTAGServiceRoute;
